// display
export const DISPLAY_NONE = 'none'
export const DISPLAY_INLINE = 'inline'
export const DISPLAY_BLOCK = 'block'
export const DISPLAY_INLINE_BLOCK = 'inline-block'
export const DISPLAY_FLEX = 'flex'
export const DISPLAY_TABLE = 'table'
export const DISPLAY_TABLE_ROW = 'table-row'
export const DISPLAY_TABLE_CELL = 'table-cell'
export const DISPLAY_GRID = 'grid'

// powers-of-two size scale
export const SIZE_AUTO = 'auto'
export const SIZE_1 = '1rem'
export const SIZE_2 = '2rem'
export const SIZE_3 = '4rem'
export const SIZE_4 = '8rem'
export const SIZE_5 = '16rem'
export const SIZE_6 = '32rem'

// overflow
export const OVERFLOW_VISIBLE = 'visible'
export const OVERFLOW_HIDDEN = 'hidden'
export const OVERFLOW_CLIP = 'clip'
export const OVERFLOW_SCROLL = 'scroll'
export const OVERFLOW_AUTO = 'auto'

// overflow wrap
export const OVERFLOW_WRAP_ANYWHERE = 'anywhere'
export const OVERFLOW_WRAP_BREAK_WORD = 'break-word'
export const OVERFLOW_WRAP_NORMAL = 'normal'
